<template>
  <div v-if="$store.state.ui.currentWorkspace">
    <div class="flex space-x-5 ml-5 mt-5">
      <ArrowLeft
        class="self-center h-6 w-6 text-common-grey cursor-pointer"
        @click="
          () => {
            $router.push(`/workspace/`)
          }
        " />
      <span class="font-medium text-xl">{{ $t("My Workspaces") }}</span>
    </div>
    <TabGroup
      :selected-index="selected_tab_index"
      class="relative m-5 transition ease-in-out rounded-lg focus:outline-none bg-light-box-background dark:bg-dark-box-background duration-side-menu-transition-duration"
      as="div"
      @change="handleSelectTab">
      <TabList
        class="flex items-start relative border-b-[1px] dark:border-dark-divider-border rounded-tl-md shadow-sm rounded-tr-md focus:outline-none">
        <Tab v-for="element in tabs" :key="element" v-slot="{ selected }" as="template">
          <div
            :style="{ color: selected && `${$store.state.ui_options.theme.selected_item_color} !important` }"
            :class="[selected ? 'text-[15px] font-normal' : 'font-normal']"
            class="sm:text-lg py-4 mx-[12px] transform translate-y-[3px] text-[#46545C] dark:text-common-grey hover:border-common-grey border-b-[2px] transition ease-in-out duration-300 rounded-sm relative focus:outline-none inline-flex ring-0 ring-offset-0 border-transparent cursor-pointer">
            {{ $t(element) }}
            <div
              :style="{ backgroundColor: selected && `${$store.state.ui_options.theme.selected_item_color} !important` }"
              :class="[
                !selected ? 'scale-0' : '',
                'absolute pointer-events-none transition transform ease-in-out duration-side-menu-transition-duration w-full h-[2px] rounded-full bottom-[-1px]'
              ]" />
          </div>
        </Tab>
      </TabList>
      <TabPanels class="shadow-lg">
        <TabPanel v-for="tab in tabs"
                  v-slot="{ selected }"
                  :key="tab"
                  static
                  class="outline-none">
          <keep-alive>
            <div v-if="selected && selected_tab_index == 0" class="w-full p-5 mt-6 h-[calc(100vh-250px)] overflow-auto">
              <WorkspaceSetup :workspace="workspace" />
            </div>

            <div v-else-if="selected && selected_tab_index == 1" class="w-full p-5 mt-6 h-[calc(100vh-250px)] overflow-auto">
              <WorkspaceVisiblePages :workspace="workspace" />
            </div>

            <div v-else-if="selected && selected_tab_index == 2" class="w-full p-5 mt-6 h-[calc(100vh-250px)] overflow-auto">
              <WorkspaceAccess :workspace="workspace" />
            </div>

            <div v-else-if="selected_tab_index == 3 && selected" class="w-full p-5 mt-6 h-[calc(100vh-250px)] overflow-auto">
              <WorkspaceNotificationsAndAnalytics :workspace="workspace" />
            </div>
          </keep-alive>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </div>

  <div v-else class="mt-10 ml-20">
    {{ $t("Loading workspace...") }}
  </div>
</template>

<script>
import { ArrowLeft } from "lucide-vue-next"
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/vue"
import WorkspaceSetup from "./tabs/WorkspaceSetup"
import WorkspaceVisiblePages from "./tabs/WorkspaceVisiblePages"
import WorkspaceAccess from "./tabs/WorkspaceAccess"
import WorkspaceNotificationsAndAnalytics from "./tabs/WorkspaceNotificationsAndAnalytics"

import dataService from "@/services/data.service"

export default {
  components: {
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    WorkspaceSetup,
    WorkspaceVisiblePages,
    WorkspaceAccess,
    WorkspaceNotificationsAndAnalytics,
    ArrowLeft
  },
  emits: [],
  data() {
    return {
      selected_tab_index: 0,
      // tabs: ["Workspace Setup", "Visible Pages", "Access", "Activity Log"],
      tabs: ["Workspace Setup", "Visible Pages", "Access"]
    }
  },

  computed: {
    workspace() {
      return this.$store.state.ui.currentWorkspace
    }
  },
  watch: {
    workspace() {
      this.redirectIfNotAdmin()
    }
  },

  activated() {
    this.redirectIfNotAdmin()
    if (this.$route.query.tab) {
      const index = this.tabs.findIndex((t) => t.replaceAll(" ", "_").toLocaleLowerCase() == this.$route.query.tab)
      this.selected_tab_index = index
    }

    if (this.$route.params.wid) {
      this.$store.dispatch("ui/setCurrentWorkspace", null)
      dataService.getWorkspace(this.$route.params.wid).then((res) => {
        this.$store.dispatch("ui/setCurrentWorkspace", res.data)
      })
    }
  },
  created() {
    this.redirectIfNotAdmin()
    if (this.$route.query.tab) {
      const index = this.tabs.findIndex((t) => t.replaceAll(" ", "_").toLocaleLowerCase() == this.$route.query.tab)
      this.selected_tab_index = index
    }
  },

  methods: {
    redirectIfNotAdmin() {
      if (this.workspace) {
        const collaborator = [
          ...this.$store.state.ui.currentWorkspace?.team_members,
          ...this.$store.state.ui.currentWorkspace?.contacts
        ]?.find((c) => c.id == this.$store.state.auth.user.id)
        if (collaborator?.workspace_access?.access_scope !== "admin") {
          this.$router.replace("/workspace")
        }
      }
    },
    handleSelectTab(e) {
      this.$router.push(`?tab=${this.tabs[e].replaceAll(" ", "_").toLocaleLowerCase()}`)
    }
  }
}
</script>
